<template>
  <div class="hot-broadcast-box">
    <div class="hot-broadcast-title">今日热播</div>
    <div class="live-list">
      <div class="swiper-box">
        <div class="swiper-wrapper">
          <div
            :key="index"
            class="swiper-slide"
            v-for="(item, index) in currentList"
          >
            <div class="video-item-container">
              <div class="video-item-box cs" @click="toVHall(item)">
                <div class="item-title ellipsis-2">
                  {{ item.m_keyMeetingName || item.name }}
                </div>
                <div class="item-time">
                  <img
                    src="../../assets/images/agenda/time.png"
                    alt=""
                    class="icon"
                  />{{ item.date }}
                </div>
                <div
                  class="status flex justify-start align-center"
                  :class="statusList[item.status]"
                >
                  <div class="status-dot"></div>
                  <div class="status-title">
                    {{ statusTitleList[item.status] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev cs">
        <img src="../../assets/images/videos/arrow.png" />
      </div>
      <div class="swiper-button-next cs">
        <img src="../../assets/images/videos/arrow.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper } from "vue-awesome-swiper";
export default {
  name: "HotBroadcast",
  props: {
    liveList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    const self = this;
    const params = {
      slidesPerView: "auto",
      loop: false,
      centeredSlides: false, //居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
      initialSlide: 0,
      mousewheel: false,
      mousewheelControl: false,
      loopAdditionalSlides: 0,
      navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
        disabledClass: "swiper-button-disable",
      },
      on: {
        click(e) {
          const realIndex = this.realIndex;
          self.toVHall(self.liveList[realIndex]);
        },
      },
    };
    this.currentList = this.liveList
      .filter((live) => {
        live.customSort = 0;
        if (live.status === 1) {
          live.customSort = 1;
        }
        if (live.status === 0) {
          live.customSort = 2;
        }
        if (live.status === 3) {
          live.customSort = 3;
        }
        return live.liveType !== "专场" && live.status !== 2;
      })
      .sort((a, b) => {
        if (a.customSort !== b.customSort) {
          return a.customSort - b.customSort;
        }
        if (a.startTime - b.startTime !== 0) {
          return a.startTime - b.startTime;
        }
        if (a.endTime - b.endTime !== 0) {
          return a.endTime - b.endTime;
        }
        return a.createTime - b.createTime;
      });
    this.$nextTick(() => {
      if (!this.$store.state.isMobile) {
        new Swiper(".swiper-box", params);
      }
    });
  },
  data() {
    return {
      statusList: ["not-started", "in-progress", "end", "playback"],
      statusTitleList: ["敬请期待", "直播中", "直播结束", "直播回顾"],
      currentList: [],
    };
  },
  methods: {
    toVHall(item) {
      //埋码
      window._hw("send", "action", "index_today_agenda_click", {
        agenda_name: item.file_name,
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
        product_tag: item.m_productTag
          ? item.m_productTag.substring(0, item.m_productTag.indexOf("$"))
          : "",
        industry_tag: item.m_industryTag
          ? item.m_industryTag.substring(0, item.m_industryTag.indexOf("$"))
          : "",
        sub_product_tag: item.m_productTag
          ? item.m_productTag.substring(
              item.m_productTag.indexOf("$") + 1,
              item.m_productTag.length
            )
          : "",
        sub_industry_tag: item.m_industryTag
          ? item.m_industryTag.substring(
              item.m_industryTag.indexOf("$") + 1,
              item.m_industryTag.length
            )
          : "",
        solution_tag: "",
      });
      //完成任务 区分下直播还是回看
      let desc = "";
      if (item.status == 1) {
        desc = "直播传送门";
      }
      if (item.status == 3) {
        desc = "追寻回声";
      }
      if (desc) {
        this.$store
          .dispatch("interaction/onCompleteTask", {
            desc: desc,
            objectId: item.subSeminarId,
            allLog: true, //总是记录日志 旅程报告要统计
          })
          .finally(() => {
            if (this.$store.state.isMobile) {
              window.location.href = item.m_vhallUrl;
            } else {
              window.open(item.m_vhallUrl);
            }
          });
      } else {
        if (this.$store.state.isMobile) {
          window.location.href = item.m_vhallUrl;
        } else {
          window.open(item.m_vhallUrl);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  [class$="-wap"] {
    display: none;
  }
  .hot-broadcast-box {
    margin-top: 50px;
    .hot-broadcast-title {
      font-size: 32px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #151e26;
    }
    .live-list {
      position: relative;
      .swiper-button-prev {
        pointer-events: all;
        cursor: pointer;
        width: 69px;
        height: 69px;
        z-index: 100;
        background: #151e26;
        opacity: 0.24;
        position: absolute;
        top: 100px;
        left: -35px;
        border-radius: 50%;
        line-height: 69px;
        text-align: center;

        &::after {
          content: "";
        }

        img {
          width: 30px;
          height: 16px;
          transform: rotate(90deg);
        }
      }

      .swiper-button-prev:hover {
        background-color: rgba(180, 37, 30, 1);
      }

      .swiper-button-next {
        pointer-events: all;
        cursor: pointer;
        width: 69px;
        height: 69px;
        z-index: 100;
        opacity: 0.24;
        position: absolute;
        top: 100px;
        right: -35px;
        background-color: #151e26;
        border-radius: 50%;
        line-height: 69px;
        text-align: center;

        &::after {
          content: "";
        }

        img {
          width: 30px;
          height: 16px;
          transform: rotate(270deg);
        }
      }

      .swiper-button-next:hover {
        background-color: rgba(180, 37, 30, 1);
      }
      .swiper-button-disable {
        background-color: #151e26;
        cursor: not-allowed;
      }
      .swiper-button-disable:hover {
        background-color: #151e26;
      }
    }
    .swiper-box {
      width: 1620px;
      height: 200px;
      margin-left: -10px;
      padding-top: 20px;
      overflow: hidden;

      .swiper-slide {
        width: calc(100% / 5);

        .video-item-container {
          width: 100%;
          height: 180px;
          position: relative;
          .video-item-box {
            width: 300px;
            height: 170px;
            position: absolute;
            background: #eff2f9;
            bottom: 0;
            left: 10px;
            background-image: url("../../assets/images/live/hot-item-bg.png");
            background-size: 233px 124px;
            background-repeat: no-repeat;
            background-position: right bottom;
            .item-title {
              padding-right: 32px;
              margin-top: 43px;
              margin-left: 32px;
              font-size: 18px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #333333;
              text-align: justify;
              word-break: break-all;
              text-justify: distribute;
            }
            .item-time {
              margin-top: 8px;
              margin-left: 32px;
              font-size: 16px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              display: flex;
              align-items: center;
              .icon {
                flex-shrink: 0;
                margin-right: 8px;
                width: 16px;
                border-radius: 50%;
              }
            }
            &:hover {
              box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.07),
                5px 0 5px rgba(0, 0, 0, 0.07), -5px 0 5px rgba(0, 0, 0, 0.07);
              width: 310px;
              height: 180px;
              bottom: 0;
              left: 5px;
              .item-title {
                //margin-top: 53px;
                //margin-left: 41px;
                text-align: justify;
                word-break: break-all;
                text-justify: distribute;
              }
              .item-time {
                //margin-top: 8px;
                //margin-left: 41px;
              }
            }

            .status {
              font-size: 14px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              position: absolute;
              right: 10px;
              top: 10px;
              width: 104px;
              height: 28px;
              display: flex;

              .status-dot {
                margin-left: 14px;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                margin-right: 6px;
              }

              &.in-progress {
                background: url("../../assets/images/live/status-in-progress.png");
                background-size: 100% 100%;
                color: #b4251e;

                .status-dot {
                  background: #b4251e;
                }
              }

              &.end {
                background: url("../../assets/images/live/status-end.png");
                background-size: 100% 100%;
                color: #888888;

                .status-dot {
                  background: #888888;
                }
              }

              &.playback {
                background: url("../../assets/images/live/status-playback.png");
                background-size: 100% 100%;
                color: #31b4e7;

                .status-dot {
                  background: #31b4e7;
                }
              }

              &.not-started {
                background: url("../../assets/images/live/status-not-started.png");
                background-size: 100% 100%;
                color: #f39c62;

                .status-dot {
                  background: #f39c62;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  [class$="-pc"] {
    display: none;
  }
  .hot-broadcast-box {
    width: calc(100% - 70px);
    margin-top: 75px;
    padding-left: 35px;
    .hot-broadcast-title {
      font-size: 30px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #151e26;
      padding-bottom: 24px;
    }
    .live-list {
      position: relative;
      width: 100%;
      .swiper-button-prev {
        display: none;
      }

      .swiper-button-next {
        display: none;
      }
    }
    .swiper-box {
      margin-left: -35px;
      margin-right: 35px;
      padding-left: 35px;
      padding-right: 35px;
      width: calc(100% + 105px);
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        display: none;
      }

      .swiper-slide {
        &:not(:first-child) {
          margin-left: 30px;
        }
        &:last-child {
          width: calc(390px + 35px);
          margin-right: 35px;
        }
        width: 390px;
        .video-item-container {
          width: 390px;
          height: 220px;
          position: relative;
          background: #eff2f9;
          background-image: url("../../assets/images/live/hot-item-bg-wap.png");
          background-size: 282px 150px;
          background-repeat: no-repeat;
          background-position: right bottom;
          .video-item-box {
            width: 390px;
            height: calc(220px - 56px);
            padding-top: 56px;
            .item-title {
              padding-right: 43px;
              margin-left: 43px;
              font-size: 28px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #333333;
            }
            .item-time {
              margin-top: 16px;
              margin-left: 43px;
              font-size: 24px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              display: flex;
              align-items: center;
              .icon {
                flex-shrink: 0;
                margin-right: 9px;
                width: 24px;
              }
            }

            .status {
              font-size: 21px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #31b4e7;
              position: absolute;
              right: 10px;
              top: 10px;
              width: 138px;
              height: 36px;
              display: flex;

              .status-dot {
                margin-left: 20px;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                margin-right: 10px;
              }

              &.in-progress {
                background: url("../../assets/images/live/status-in-progress.png");
                background-size: 100% 100%;
                color: #b4251e;

                .status-dot {
                  background: #b4251e;
                }
              }

              &.end {
                background: url("../../assets/images/live/status-end.png");
                background-size: 100% 100%;
                color: #888888;

                .status-dot {
                  background: #888888;
                }
              }

              &.playback {
                background: url("../../assets/images/live/status-playback.png");
                background-size: 100% 100%;
                color: #31b4e7;

                .status-dot {
                  background: #31b4e7;
                }
              }

              &.not-started {
                background: url("../../assets/images/live/status-not-started.png");
                background-size: 100% 100%;
                color: #f39c62;

                .status-dot {
                  background: #f39c62;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
